const MundMemberkit = (props) => (
  <svg
    width={88}
    height={56}
    viewBox="0 0 88 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3848_75637)">
      <rect
        x={3.50488}
        y={13.8579}
        width={40}
        height={40}
        rx={10}
        transform="rotate(-15 3.50488 13.8579)"
        fill="url(#paint0_linear_3848_75637)"
      />
      <g clipPath="url(#clip1_3848_75637)">
        <path
          d="M26.0782 15.3202L25.2322 16.5812C25.1136 16.7583 24.8855 16.8194 24.6942 16.7253L23.3277 16.0524C23.2183 15.9983 23.0886 15.9925 22.9776 16.039C22.2987 16.321 21.6254 16.6682 20.9644 17.0789C17.4743 19.2485 15.2675 23.0547 15.1143 27.1758C14.8342 34.8436 20.5852 40.395 27.1835 40.829C28.543 40.9176 29.9398 40.7911 31.3277 40.4192C32.7157 40.0473 33.9886 39.4584 35.1217 38.702C39.5809 35.7222 41.8726 30.0987 40.4028 24.6132C38.7155 18.3162 32.6423 14.343 26.374 15.1313C26.2525 15.1472 26.1425 15.2148 26.0732 15.3191L26.0782 15.3202ZM18.1565 31.7824L18.1581 31.7795L21.9767 30.7564C22.1772 30.8671 22.294 30.9311 22.4923 31.0424C23.3437 33.6622 24.4822 35.8833 25.7497 37.5145C25.9995 37.8361 25.7041 38.2918 25.3113 38.1897C22.1249 37.3395 19.4058 35.0104 18.1527 31.7858L18.1565 31.7824ZM30.803 38.16C30.7771 38.1693 30.7527 38.1758 30.7284 38.1824C30.704 38.1889 30.6797 38.1954 30.6525 38.2003C29.2126 38.467 26.475 35.7235 24.736 30.4817C24.6595 30.2496 24.7941 29.9991 25.0287 29.9362L31.5413 28.1911C31.776 28.1283 32.0177 28.278 32.0676 28.5172C33.1824 33.9262 32.1811 37.6716 30.803 38.16ZM35.4211 35.4808C35.1348 35.7672 34.6505 35.518 34.7039 35.1153C34.9992 32.9675 34.8453 30.3301 34.1989 27.4838C34.1983 27.4816 34.2005 27.481 34.2005 27.481L33.7102 25.651C33.6494 25.4242 33.4162 25.2889 33.1904 25.3494L18.0246 29.4131C17.7701 29.4813 17.5199 29.3004 17.4919 29.0363C17.1486 25.7894 18.3299 22.6274 20.5518 20.4091C20.8402 20.1221 21.323 20.374 21.2679 20.7796C21.0627 22.2717 21.0753 24.0009 21.3167 25.8761C21.3491 26.1296 21.6028 26.2975 21.8486 26.2317L23.2675 25.8515C23.4712 25.7969 23.6027 25.5972 23.5773 25.3871C23.0534 21.0591 23.9675 18.1569 25.1698 17.7299L25.3182 17.6901C26.573 17.4588 28.8178 19.5145 30.526 23.5253C30.609 23.7199 30.8205 23.8276 31.0264 23.7725L32.4431 23.3929C32.6889 23.327 32.8253 23.0569 32.7259 22.819C32.0025 21.0753 31.1465 19.5721 30.2244 18.3798C29.9745 18.0582 30.2682 17.5959 30.6593 17.7008C33.8379 18.5483 36.5496 20.8674 37.807 24.0814C37.8118 24.0992 37.8188 24.1164 37.8235 24.1342L38.4104 26.3244C38.4152 26.3421 38.4199 26.3599 38.4225 26.3783C38.9405 29.7904 37.7495 33.1553 35.4205 35.4785L35.4211 35.4808Z"
          fill="url(#paint1_linear_3848_75637)"
        />
      </g>
    </g>
    <path
      d="M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z"
      fill="white"
    />
    <path
      d="M45.6656 33.2178L66.5439 38.8121L59.9293 19.8245C59.9293 19.8245 59.8041 18.8889 58.074 18.4253C56.5777 18.0244 55.9079 18.747 55.9079 18.747L45.0402 28.1638C45.0402 28.1638 43.6561 29.1211 43.9782 30.9114C44.2996 32.6971 45.6656 33.2178 45.6656 33.2178Z"
      fill="#2726B0"
    />
    <path
      d="M70.764 39.9431L49.8857 34.3488L65.1079 21.2123C65.1079 21.2123 65.6842 20.4646 67.4143 20.9282C68.9106 21.3291 69.1293 22.2899 69.1293 22.2899L73.8326 35.8789C73.8326 35.8789 74.5527 37.4 73.3785 38.7893C72.2074 40.1751 70.764 39.9431 70.764 39.9431Z"
      fill="url(#paint2_linear_3848_75637)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3848_75637"
        x1={23.5049}
        y1={13.8579}
        x2={23.5049}
        y2={53.8579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29282C" />
        <stop offset={1} stopColor="#100F11" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3848_75637"
        x1={10.6936}
        y1={13.8569}
        x2={35.8057}
        y2={35.4541}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3848_75637"
        x1={53.2878}
        y1={26.5149}
        x2={75.3584}
        y2={32.4287}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1BEEEA" />
        <stop offset={0.5} stopColor="#699DF1" />
        <stop offset={1} stopColor="#D4A1F2" />
      </linearGradient>
      <clipPath id="clip0_3848_75637">
        <rect
          x={3.50488}
          y={13.8579}
          width={40}
          height={40}
          rx={10}
          transform="rotate(-15 3.50488 13.8579)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_3848_75637">
        <rect
          width={30}
          height={30}
          fill="white"
          transform="translate(9.62891 17.3936) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default MundMemberkit;